import { FunctionComponent, useState } from 'react';

import { BUTTON_TYPES, UI_SIZE } from '@savgroup-front-common/constants/shared';
import { GetFullClaimContextQueryReturnValues } from '@savgroup-front-common/core/api/Claim/getFullClaimContextQuery';
import { Collapse } from '@savgroup-front-common/core/atoms/Collapse';
import { Tag } from '@savgroup-front-common/core/atoms/Tag';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { Divider } from '@savgroup-front-common/core/protons/Divider/Divider';
import { DENSITY } from '@savgroup-front-common/core/protons/Divider/Divider.types';
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from '@savgroup-front-common/core/protons/icons';

import FileDocument from './FileDocument/FileDocument';
import useGetDocuments from './FileDocuments.hooks';
import {
  $CollapsableButton,
  $DocumentsWrapper,
  $FileHeader,
  $Header,
  $HeaderLeft,
  $NoDocumentAvailable,
} from './FileDocuments.styles';
import messages from './messages';

const FileDocuments: FunctionComponent<{
  fullClaim: GetFullClaimContextQueryReturnValues;
}> = ({ fullClaim }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { allDocuments } = useGetDocuments({ fullClaim });

  return (
    <div>
      <$Header>
        <$HeaderLeft>
          <$FileHeader>
            <SafeFormattedMessageWithoutSpread message={messages.titleCard} />
          </$FileHeader>

          <Tag isHollow size={UI_SIZE.XS} withoutMargin>
            {allDocuments?.length}
          </Tag>
        </$HeaderLeft>
        <$CollapsableButton
          onClick={() => setIsOpen(!isOpen)}
          type={BUTTON_TYPES.BUTTON}
        >
          {isOpen && <ChevronUpIcon />}
          {!isOpen && <ChevronDownIcon />}
        </$CollapsableButton>
      </$Header>

      <Divider density={DENSITY.COMFORTABLE} />

      <Collapse isOpen={isOpen} couldUnmountIfClosed={true}>
        <$DocumentsWrapper>
          {allDocuments?.map((document) => (
            <FileDocument
              key={
                document.originalFileName ||
                document.attachmentId ||
                document.documentName ||
                document.carrierLabelId
              }
              document={document}
            />
          ))}

          {allDocuments.length === 0 && (
            <$NoDocumentAvailable>
              <SafeFormattedMessageWithoutSpread
                message={messages.noDocuments}
              />
            </$NoDocumentAvailable>
          )}
        </$DocumentsWrapper>
      </Collapse>
    </div>
  );
};

export default FileDocuments;
